import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter} from '@angular/core';
import {trigger, style, animate, transition, query, keyframes, state} from '@angular/animations';
import {Router} from "@angular/router";
import {ApiService} from "../api.service";
import {Report} from "../report/report";
import {CommonService} from "../common.service";
import { appRenameFixed } from "../appRenameFixed";
declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-ability-test-report',
  animations: [
    trigger('card1Animation', [
      state("showCard1", style({opacity: 1, transform: 'scale(1, 1)'})),
      state("hideCard1", style({opacity: 0, transform: 'scale(0, 0)'})),
      transition('hideCard1 => showCard1', animate('400ms', keyframes([
        style({transform: 'scale(1, 1)', opacity: 0}),
        style({transform: 'scale(1, 1)', opacity: 0}),
        style({transform: 'scale(1, 1)', opacity: 0}),
        style({transform: 'scale(1, 1)', opacity: 0}),
        style({transform: 'scale(1, 1)', opacity: 0.15}),
        style({transform: 'scale(1, 1)', opacity: 0.45}),
        style({transform: 'scale(1, 1)', opacity: 0.5}),
        style({transform: 'scale(1, 1)', opacity: 0.75}),
        style({transform: 'scale(1, 1)', opacity: 0.9}),
        style({transform: 'scale(1, 1)', opacity: 1})
      ])),
    ),
    transition('showCard1 => hideCard1', animate('400ms', keyframes([
      style({transform: 'scale(1, 1) translate(0, -0.05rem)', opacity: 1}),
      style({transform: 'scale(1.001, 1.001) translate(0, -0.1rem)', opacity: 0.75}),
      style({transform: 'scale(1.002, 1.002) translate(0, -0.1rem)', opacity: 0.6}),
      style({transform: 'scale(1.003, 1.003) translate(0, -0.1rem)', opacity: 0.45}),
      style({transform: 'scale(1.004, 1.004) translate(0, -0.1rem)', opacity: 0.3}),
      style({transform: 'scale(1.005, 1.005) translate(0, -0.1rem)', opacity: 0.1}),
      style({transform: 'scale(1.006, 1.006) translate(0, -0.1rem)', opacity: 0.1}),
      style({transform: 'scale(1.007, 1.007) translate(0, -0.1rem)', opacity: 0.1}),
      style({transform: 'scale(1.008, 1.008) translate(0, -0.1rem)', opacity: 0.1}),
      style({transform: 'scale(1.009, 1.009) translate(0, -0.1rem)', opacity: 0}),
      style({transform: 'scale(1.01, 1.01) translate(0, -0.1rem)', opacity: 0})
    ])),
  ),
]),
trigger('card2Animation', [
  state("showCard2", style({opacity: 1, transform: 'scale(1, 1)'})),
  state("hideCard2", style({opacity: 0, transform: 'scale(0, 0)'})),
  transition('hideCard2 => showCard2', animate('400ms', keyframes([
    style({transform: 'scale(1, 1)', opacity: 0}),
    style({transform: 'scale(1, 1)', opacity: 0}),
    style({transform: 'scale(1, 1)', opacity: 0}),
    style({transform: 'scale(1, 1)', opacity: 0}),
    style({transform: 'scale(1, 1)', opacity: 0.15}),
    style({transform: 'scale(1, 1)', opacity: 0.45}),
    style({transform: 'scale(1, 1)', opacity: 0.5}),
    style({transform: 'scale(1, 1)', opacity: 0.75}),
    style({transform: 'scale(1, 1)', opacity: 0.9}),
    style({transform: 'scale(1, 1)', opacity: 1})
  ])),
),
transition('showCard2 => hideCard2', animate('400ms', keyframes([
  style({transform: 'scale(1, 1) translate(0, -0.05rem)', opacity: 1}),
  style({transform: 'scale(1.001, 1.001) translate(0, -0.1rem)', opacity: 0.75}),
  style({transform: 'scale(1.002, 1.002) translate(0, -0.1rem)', opacity: 0.6}),
  style({transform: 'scale(1.003, 1.003) translate(0, -0.1rem)', opacity: 0.45}),
  style({transform: 'scale(1.004, 1.004) translate(0, -0.1rem)', opacity: 0.3}),
  style({transform: 'scale(1.005, 1.005) translate(0, -0.1rem)', opacity: 0.1}),
  style({transform: 'scale(1.006, 1.006) translate(0, -0.1rem)', opacity: 0.1}),
  style({transform: 'scale(1.007, 1.007) translate(0, -0.1rem)', opacity: 0.1}),
  style({transform: 'scale(1.008, 1.008) translate(0, -0.1rem)', opacity: 0.1}),
  style({transform: 'scale(1.009, 1.009) translate(0, -0.1rem)', opacity: 0}),
  style({transform: 'scale(1.01, 1.01) translate(0, -0.1rem)', opacity: 0})
])),
),
]),
trigger('detail1Animation', [
  state("showDetail1", style({opacity: 1, transform: 'scale(1, 1)'})),
  state("hideDetail1", style({opacity: 0, transform: 'scale(0, 0)'})),
  transition('hideDetail1 => showDetail1', animate('400ms', keyframes([
    style({transform: 'scale(1, 0)', opacity: 0, transformOrigin: '1.77rem 2.5rem'}),
    style({transform: 'scale(1, 0)', opacity: 0, transformOrigin: '1.77rem 2.5rem'}),
    style({transform: 'scale(1, 0)', opacity: 0.25, transformOrigin: '1.77rem 2.5rem'}),
    style({transform: 'scale(1, 0.35)', opacity: 0.35, transformOrigin: '1.77rem 2.5rem'}),
    style({transform: 'scale(1, 0.45)', opacity: 0.5, transformOrigin: '1.77rem 2.5rem'}),
    style({transform: 'scale(1, 0.55)', opacity: 0.75, transformOrigin: '1.77rem 2.5rem'}),
    style({transform: 'scale(1, 0.65)', opacity: 0.9, transformOrigin: '1.77rem 2.5rem'}),
    style({transform: 'scale(1, 0.75)', opacity: 1, transformOrigin: '1.77rem 2.5rem'}),
    style({transform: 'scale(1, 0.9)', opacity: 1, transformOrigin: '1.77rem 2.5rem'}),
    style({transform: 'scale(1, 1)', opacity: 1, transformOrigin: '1.77rem 2.5rem'})
  ])),
),
transition('showDetail1 => hideDetail1', animate('400ms', keyframes([
  style({transform: 'scale(1, 1)', opacity: 1, transformOrigin: '1.77rem 2.5rem'}),
  style({transform: 'scale(1, 0.9)', opacity: 1, transformOrigin: '1.77rem 2.5rem'}),
  style({transform: 'scale(1, 0.8)', opacity: 1, transformOrigin: '1.77rem 2.5rem'}),
  style({transform: 'scale(1, 0.7)', opacity: 1, transformOrigin: '1.77rem 2.5rem'}),
  style({transform: 'scale(1, 0.6)', opacity: 1, transformOrigin: '1.77rem 2.5rem'}),
  style({transform: 'scale(1, 0.5)', opacity: 0.75, transformOrigin: '1.77rem 2.5rem'}),
  style({transform: 'scale(1, 0.4)', opacity: 0.5, transformOrigin: '1.77rem 2.5rem'}),
  style({transform: 'scale(1, 0.35)', opacity: 0.25, transformOrigin: '1.77rem 2.5rem'})
])),
),
]),
trigger('detail2Animation', [
  state("showDetail2", style({opacity: 1, transform: 'scale(1, 1)'})),
  state("hideDetail2", style({opacity: 0, transform: 'scale(0, 0)'})),
  transition('hideDetail2 => showDetail2', animate('400ms', keyframes([
    style({transform: 'scale(1, 0)', opacity: 0, transformOrigin: '5.61rem 2.5rem'}),
    style({transform: 'scale(1, 0)', opacity: 0, transformOrigin: '5.61rem 2.5rem'}),
    style({transform: 'scale(1, 0)', opacity: 0.25, transformOrigin: '5.61rem 2.5rem'}),
    style({transform: 'scale(1, 0.35)', opacity: 0.35, transformOrigin: '5.61rem 2.5rem'}),
    style({transform: 'scale(1, 0.45)', opacity: 0.5, transformOrigin: '5.61rem 2.5rem'}),
    style({transform: 'scale(1, 0.55)', opacity: 0.75, transformOrigin: '5.61rem 2.5rem'}),
    style({transform: 'scale(1, 0.65)', opacity: 0.9, transformOrigin: '5.61rem 2.5rem'}),
    style({transform: 'scale(1, 0.75)', opacity: 1, transformOrigin: '5.61rem 2.5rem'}),
    style({transform: 'scale(1, 0.9)', opacity: 1, transformOrigin: '5.61rem 2.5rem'}),
    style({transform: 'scale(1, 1)', opacity: 1, transformOrigin: '5.61rem 2.5rem'})
  ])),
),
transition('showDetail2 => hideDetail2', animate('400ms', keyframes([
  style({transform: 'scale(1, 1)', opacity: 1, transformOrigin: '5.61rem 2.5rem'}),
  style({transform: 'scale(1, 0.9)', opacity: 1, transformOrigin: '5.61rem 2.5rem'}),
  style({transform: 'scale(1, 0.8)', opacity: 1, transformOrigin: '5.61rem 2.5rem'}),
  style({transform: 'scale(1, 0.7)', opacity: 1, transformOrigin: '5.61rem 2.5rem'}),
  style({transform: 'scale(1, 0.6)', opacity: 1, transformOrigin: '5.61rem 2.5rem'}),
  style({transform: 'scale(1, 0.5)', opacity: 0.75, transformOrigin: '5.61rem 2.5rem'}),
  style({transform: 'scale(1, 0.4)', opacity: 0.5, transformOrigin: '5.61rem 2.5rem'}),
  style({transform: 'scale(1, 0.35)', opacity: 0.25, transformOrigin: '5.61rem 2.5rem'})
])),
),
]),
],
templateUrl: './ability-test-report.component.html',
styleUrls: ['./ability-test-report.component.css',]
})
export class AbilityTestReportComponent implements OnInit, AfterViewInit {
  report: any;
  @Input() surveyId: number;
  @Input() tourSingleReport: any;
  @Input() surveyType: number;
  @Input() learningPathId: string;
  @Output() onGoBackSurvey = new EventEmitter<any>();

	appRename:appRenameFixed = new appRenameFixed();
  learningTour: any;
  learningPath: any;
  learningPathMetaId: any;

  preLevel: number;
  postLevel: number;
  description: string;
  development: string;
  chuanjie: any;

  preSurveyId: number;
  postSurveyId: number;

  preReport: any;
  postReport: any;

  reportName: any;

  detail1Show: boolean;
  detail2Show: boolean;
  card1Show: boolean;
  card2Show: boolean;
  finishStatus: boolean;

  mode: number;
  constructor(private router: Router, private apiService: ApiService,
    private commonService: CommonService) { }

    ngOnInit() {
      let that = this;
      this.card1Show = true;
      this.card2Show = true;
      this.detail1Show = false;
      this.detail2Show = false;
      if(this.learningPathId!='not'){
        this.apiService.ajax({
          'type': 'get',
          'url': '/api/concatenation/' + this.learningPathId,
          'data': {
            'learningPathId': this.learningPathId,
          }
        }).subscribe(comment => {
          comment.forEach(function (item,index) {
              if(item.title=='能力诊断'){
                that.chuanjie = item.comment;
              }
          });
          /*this.chuanjie = comment[1].comment;*/
        });
        this.apiService.ajax({
          'type': 'get',
          'url':'/api/learningpathes/'+this.learningPathId
        }).subscribe(result=>{
          this.learningPath = result;
          this.learningPath.subItems.forEach(function (item,index) {
            if(item.type==1){
              that.preSurveyId = item.id;
            }else if(item.type==4){
              that.postSurveyId = item.id;
            }
          });
          if(this.preSurveyId == this.surveyId){
            this.mode = 1;
            this.apiService.getReport("" + this.preSurveyId + "").subscribe(result => {
              this.preReport = result.details[0];
              this.reportName = this.preReport.name;
              this.preLevel = this.preReport.level;
              this.description = this.preReport.description;
              this.development = this.preReport.development;
            });
          }else{
            this.mode = 2;
            this.apiService.getReport("" + this.postSurveyId + "").subscribe(result => {
              this.postReport = result.details[0];
              this.reportName = this.postReport.name;
              this.postLevel = this.postReport.level;
              this.description = this.postReport.description;
              this.development = this.postReport.development;
              this.apiService.getReport("" + this.preSurveyId + "").subscribe(result => {
                this.preReport = result.details[0];
                this.preLevel = this.preReport.level;
              });
            });
            if(this.learningPath.name=="辅导"){
              this.apiService.ajax({
                'type':'get',
                'url': '/sr/onceino/105',
                'data':{}
              }).subscribe(result=>{
                this.finishStatus = result==1?true:false;
              });
            } else if(this.learningPath.name=="打造高效团队"){
              this.apiService.ajax({
                'type':'get',
                'url': '/sr/onceino/115',
                'data':{}
              }).subscribe(result=>{
                this.finishStatus = result==1?true:false;
              });
            }else if(this.learningPath.name=="授权"){
              this.apiService.ajax({
                'type':'get',
                'url': '/sr/onceino/125',
                'data':{}
              }).subscribe(result=>{
                this.finishStatus = result==1?true:false;
              });
            }else if(this.learningPath.name=="计划与组织"){
              this.apiService.ajax({
                'type':'get',
                'url': '/sr/onceino/145',
                'data':{}
              }).subscribe(result=>{
                this.finishStatus = result==1?true:false;
              });
            }else if(this.learningPath.name=="协作"){
              this.apiService.ajax({
                'type':'get',
                'url': '/sr/onceino/155',
                'data':{}
              }).subscribe(result=>{
                this.finishStatus = result==1?true:false;
              });
            }else if(this.learningPath.name=="影响力"){
              this.apiService.ajax({
                'type':'get',
                'url': '/sr/onceino/165',
                'data':{}
              }).subscribe(result=>{
                this.finishStatus = result==1?true:false;
              });
            }else if(this.learningPath.name=="决策"){
              this.apiService.ajax({
                'type':'get',
                'url': '/sr/onceino/175',
                'data':{}
              }).subscribe(result=>{
                this.finishStatus = result==1?true:false;
              });
            }
          }
        });
      }else{
        if(this.surveyType == 2){
          this.mode = 1;
          this.preReport = this.tourSingleReport;
          this.reportName = this.preReport.name;
          this.preLevel = this.preReport.level;
          this.description = this.preReport.description;
          this.development = this.preReport.development;
        }else if(this.surveyType == 3){
          this.mode = 2;
          this.postReport = this.tourSingleReport;
          this.reportName = this.postReport.name;
          this.postLevel = this.postReport.level;
          this.description = this.postReport.description;
          this.development = this.postReport.development;
          this.preLevel = this.postReport.preLevel;
          this.preReport = this.postReport.preReport;
          //   this.apiService.getReport("" + (this.reportId - 1) + "").subscribe(result => {
          //     this.preReport = result.details[0];
          //     this.preLevel = this.preReport.level;
          // });
        }
      }

      /*this.learningPath = this.getMockData2();
      this.preReport = true;
      this.chuanjie = '文案文案文案';
      this.preLevel = 1;
      this.postLevel = 3;
      this.description = '文案文案文案';*/
    }

    ngAfterViewInit(){
      this.commonService.initPage();
    }


    getCourse(){
      // if(this.learningPathId!='not'){
      //   let courseId = this.learningPath.subItems[2].id;
      //   let link = ['course', this.learningPath.id, courseId];
      //   this.router.navigate(link);
      // }else{
      //   let courseId = this.learningPath.subItems[1].id;
      //   let link = ['course', this.learningPath.id, courseId];
      //   this.router.navigate(link);
      // }
        let courseId,
            itemIndex;
        this.learningPath.subItems.forEach(function (item,index) {
            if(item.type==2){
                courseId = item.id;
                itemIndex = index;
            }
        });


      this.apiService.ajax({
        'type':'GET',
        'url': '/ddilearner/v1/getLearningPathMetaId/' + this.learningPath.id
      }).subscribe(result=>{
        this.learningPathMetaId = result.data;
        this.apiService.ajax({
          'type':'GET',
          'url':'/sr/exposeoutapi/setAbilitySession/'+this.learningPathMetaId+'/2'
        }).subscribe(result=>{});
      });


        let link = ['course', this.learningPath.id, courseId];
        this.router.navigate(link);
    }


    close() {
      if(!this.finishStatus){
        if(this.learningPathId!='not' && this.mode == 1){
          this.apiService.ajax({
            'type': 'get',
            'url':'/ddilearner/v1/getLearningPathMetaId/'+this.learningPathId
          }).subscribe(result=>{
            let link = ['learning-path',result.data];
            this.router.navigate(link);
          });
        }else if(this.learningPathId!='not' && this.mode == 2){
          if(this.learningPath.name=="辅导"){
            this.apiService.ajax({
              'type':'post',
              'url': '/sr/onceino/105',
              'data':{}
            }).subscribe();
          } else if(this.learningPath.name=="打造高效团队"){
            this.apiService.ajax({
              'type':'post',
              'url': '/sr/onceino/115',
              'data':{}
            }).subscribe();
          }else if(this.learningPath.name=="授权"){
            this.apiService.ajax({
              'type':'post',
              'url': '/sr/onceino/125',
              'data':{}
            }).subscribe();
          }else if(this.learningPath.name=="计划与组织"){
            this.apiService.ajax({
              'type':'post',
              'url': '/sr/onceino/145',
              'data':{}
            }).subscribe();
          }else if(this.learningPath.name=="协作"){
            this.apiService.ajax({
              'type':'post',
              'url': '/sr/onceino/155',
              'data':{}
            }).subscribe();
          }else if(this.learningPath.name=="影响力"){
            this.apiService.ajax({
              'type':'post',
              'url': '/sr/onceino/165',
              'data':{}
            }).subscribe();
          }else if(this.learningPath.name=="决策"){
            this.apiService.ajax({
              'type':'post',
              'url': '/sr/onceino/175',
              'data':{}
            }).subscribe();
          }
          let link = ['learning-map'];
          this.router.navigate(link);
        }else if(this.learningPathId == 'not'){
          // let link = ['learning-map'];
          // this.router.navigate(link);
          this.onGoBackSurvey.emit();
        }
      }else{
        if(this.learningPathId!='not'){
          let link = ['learning-map'];
          this.router.navigate(link);
        }else if(this.learningPathId == 'not'){
          // let link = ['learning-map'];
          // this.router.navigate(link);
          this.onGoBackSurvey.emit();
        }
      }
    }

    finish(){
      if(this.finishStatus || this.learningPathId == 'not'){
        return;
      }else{
        if(this.learningPath.name=="辅导"){
          this.apiService.ajax({
            'type':'post',
            'url': '/sr/onceino/105',
            'data':{}
          }).subscribe();
        } else if(this.learningPath.name=="打造高效团队"){
          this.apiService.ajax({
            'type':'post',
            'url': '/sr/onceino/115',
            'data':{}
          }).subscribe();
        }else if(this.learningPath.name=="授权"){
          this.apiService.ajax({
            'type':'post',
            'url': '/sr/onceino/125',
            'data':{}
          }).subscribe();
        }else if(this.learningPath.name=="计划与组织"){
          this.apiService.ajax({
            'type':'post',
            'url': '/sr/onceino/145',
            'data':{}
          }).subscribe();
        }else if(this.learningPath.name=="协作"){
          this.apiService.ajax({
            'type':'post',
            'url': '/sr/onceino/155',
            'data':{}
          }).subscribe();
        }else if(this.learningPath.name=="影响力"){
          this.apiService.ajax({
            'type':'post',
            'url': '/sr/onceino/165',
            'data':{}
          }).subscribe();
        }else if(this.learningPath.name=="决策"){
          this.apiService.ajax({
            'type':'post',
            'url': '/sr/onceino/175',
            'data':{}
          }).subscribe();
        }
        let link = ['learning-map'];
        this.router.navigate(link);
      }
    }

    detailClick1(){
      this.card1Show = false;
      this.detail1Show = true;
      $('#shade').fadeIn(200);
      setTimeout(function(){
        $("#detailContent1").fadeIn(10);
      }, 200);
    }

    detailBtnClick1(){
      this.detail1Show = false;
      this.card1Show = true;
      $('#shade').fadeOut(200);
      setTimeout(function(){

        $("#detailContent1").fadeOut(200);

      }, 50);
    }

    detailClick2(){
      this.card2Show = false;
      this.detail2Show = true;
      $('#shade').fadeIn(200);
      setTimeout(function(){

        $("#detailContent2").fadeIn(10);

      }, 200);

    }

    detailBtnClick2(){
      this.detail2Show = false;
      this.card2Show = true;
      $('#shade').fadeOut(200);
      setTimeout(function(){

        $("#detailContent2").fadeOut(200);

      }, 50);
    }

    // getMockData1(){
    //   return {
    //     "id": 2269,
    //     "survey_id": 3310,
    //     "emotionality": 0,
    //     "emotionality_description": null,
    //     "delightful": 0,
    //     "delightful_description": null,
    //     "extroversion": 0,
    //     "extroversion_description": null,
    //     "responsibility": 0,
    //     "responsibility_description": null,
    //     "open": 0,
    //     "open_description": null,
    //     "coaching": 1,
    //     "coaching_description": "\u522b\u7070\u5fc3\uff0c\u867d\u7136\u4f60\u79bb\u5353\u8d8a\u7684\u8f85\u5bfc\u8fd8\u6709\u4e00\u5b9a\u8ddd\u79bb\uff0c\u4f46\u8fd9\u5e76\u975e\u4e0d\u53ef\u80fd\u5b8c\u6210\u7684\u4efb\u52a1\uff0c\u53ea\u9700\u8981\u4f60\u518d\u52aa\u529b\u4e00\u70b9\u70b9\uff01\u5728\u5de5\u4f5c\u4e2d\uff0c\u5982\u679c\u4f60\u6709\u8fd9\u6837\u7684\u65e0\u529b\u611f\uff1a<br\/>\n*\u4e0b\u5c5e\u505a\u7684\u5f80\u5f80\u548c\u4f60\u7684\u8981\u6c42\u76f8\u8ddd\u751a\u8fdc\u3002\u90a3\u53ef\u80fd\u662f\u56e0\u4e3a\u4f60\u5f88\u5c11\u6e05\u6670\u5730\u5411\u4e0b\u5c5e\u4f20\u8fbe\u7ee9\u6548\u671f\u671b\u548c\u8981\u6c42\u3002<br\/>\n*\u4e0b\u5c5e\u6709\u65f6\u4e0d\u77e5\u9053\u8be5\u600e\u4e48\u505a\u3002\u90a3\u53ef\u80fd\u662f\u56e0\u4e3a\u4f60\u5bf9\u4ed6\u4eec\u7684\u8868\u73b0\u8f83\u5c11\u7ed9\u4e88\u53cd\u9988\u6216\u53ea\u7ed9\u8d1f\u9762\u53cd\u9988\u3002<br\/>\n*\u4e0b\u5c5e\u7ee9\u6548\u603b\u662f\u65e0\u6cd5\u8fbe\u6807\u3002\u90a3\u53ef\u80fd\u662f\u56e0\u4e3a\u4f60\u8f83\u5c11\u63d0\u4f9b\u660e\u786e\u7684\u6307\u5f15\u6216\u53cd\u9988\uff0c\u6765\u5e2e\u52a9\u4e0b\u5c5e\u6539\u5584\u7ee9\u6548\u3002",
    //     "coaching_development": "\u563f\uff0c\u653e\u8f7b\u677e\uff0c\u4e0d\u8981\u505a\u56e2\u961f\u7684\u72ec\u88c1\u8005\u54e6\uff01\u4e0d\u7136\u4e0b\u5c5e\u4f1a\u4ee5\u4e3a\u4ed6\u4eec\u5728\u4e3a\u4e00\u4e2a\u673a\u5668\u4eba\u5de5\u4f5c\u3002<br \/>\n\u5c1d\u8bd5\u771f\u5207\u5173\u6ce8\u4e0b\u5c5e\u53d1\u5c55\u9700\u6c42\u5427\uff1a\u6df1\u5165\u4e86\u89e3\u4e0b\u5c5e\u7684\u4e2a\u4eba\u548c\u5de5\u4f5c\u53d1\u5c55\u9700\u6c42\uff0c\u5728\u5206\u914d\u4efb\u52a1\u548c\u6307\u5bfc\u4e0b\u5c5e\u524d\uff0c\u601d\u8003\u4e00\u4e0b\u4ed6\u4eec\u7684\u4e2a\u4eba\u9700\u6c42\uff0c\u5e76\u636e\u6b64\u63d0\u4f9b\u652f\u6301\u548c\u5e2e\u52a9\uff0c\u4f1a\u4f7f\u8f85\u5bfc\u4e8b\u534a\u529f\u500d\u54e6\uff01<br \/>\n\u5f00\u653e\u7075\u6d3b\u7684\u4e2a\u6027\u4f7f\u4f60\u5728\u9762\u5bf9\u6311\u6218\u65f6\uff0c\u613f\u610f\u4e3a\u4e0b\u5c5e\u548c\u56e2\u961f\u63d0\u4f9b\u66f4\u591a\u7684\u53c2\u4e0e\u548c\u51b3\u7b56\u673a\u4f1a\uff0c\u8ba9\u4ed6\u4eec\u5728\u5de5\u4f5c\u4e2d\u611f\u53d7\u5230\u66f4\u591a\u7684\u81ea\u4e3b\u6743\u3002\u7684\u786e\uff0c\u52a8\u529b\u662f\u63d0\u5347\u8f85\u5bfc\u6548\u679c\u7684\u4e00\u5242\u826f\u836f\uff0c\u6fc0\u52b1\u662f\u56e2\u961f\u6f5c\u80fd\u91ca\u653e\u7684\u50ac\u5316\u5242\u3002<br \/>\n\u660e\u786e\u4f20\u8fbe\u671f\u671b\u2014\u2014\u4f46\u8fd9\u6837\u7684\u4e2a\u6027\u4e5f\u53ef\u80fd\u4f1a\u8ba9\u4f60\u5ffd\u89c6\u7ec6\u8282\uff0c\u5728\u4f20\u8fbe\u8f85\u5bfc\u671f\u671b\u65f6\u8fc7\u4e8e\u6a21\u7cca\uff0c\u4e0b\u5c5e\u6267\u884c\u4efb\u52a1\u6216\u53d1\u5c55\u65f6\u4e5f\u5c31\u53ef\u80fd\u8fc7\u4e8e\u653e\u98de\u4e86\u3002\u8bf7\u5c3d\u91cf\u4f20\u8fbe\u660e\u786e\u4e14\u53ef\u8861\u91cf\u7684\u671f\u671b\uff0c\u6709\u9488\u5bf9\u6027\u5730\u63d0\u4f9b\u53d1\u5c55\u7a7a\u95f4\u548c\u6307\u5bfc\uff0c\u4f1a\u6709\u66f4\u5927\u7684\u6536\u83b7\u54e6\uff01<br \/>",
    //     "guiding": 0,
    //     "guiding_description": null,
    //     "guiding_development": null,
    //     "created_time": "2018-06-07 10:48:08",
    //     "updated_time": "2018-06-07 10:48:08",
    //     "characterFinished": 0,
    //     "details": [{
    //       "id": 485,
    //       "report_id": 2269,
    //       "user_id": 355,
    //       "learning_tour_id": 514,
    //       "survey_type": 2,
    //       "ability_id": 6,
    //       "raw_point": 171,
    //       "norm_point": 1,
    //       "level": 1,
    //       "grade": "L",
    //       "description": "\u522b\u7070\u5fc3\uff0c\u867d\u7136\u4f60\u79bb\u5353\u8d8a\u7684\u8f85\u5bfc\u8fd8\u6709\u4e00\u5b9a\u8ddd\u79bb\uff0c\u4f46\u8fd9\u5e76\u975e\u4e0d\u53ef\u80fd\u5b8c\u6210\u7684\u4efb\u52a1\uff0c\u53ea\u9700\u8981\u4f60\u518d\u52aa\u529b\u4e00\u70b9\u70b9\uff01\u5728\u5de5\u4f5c\u4e2d\uff0c\u5982\u679c\u4f60\u6709\u8fd9\u6837\u7684\u65e0\u529b\u611f\uff1a<br\/>\n*\u4e0b\u5c5e\u505a\u7684\u5f80\u5f80\u548c\u4f60\u7684\u8981\u6c42\u76f8\u8ddd\u751a\u8fdc\u3002\u90a3\u53ef\u80fd\u662f\u56e0\u4e3a\u4f60\u5f88\u5c11\u6e05\u6670\u5730\u5411\u4e0b\u5c5e\u4f20\u8fbe\u7ee9\u6548\u671f\u671b\u548c\u8981\u6c42\u3002<br\/>\n*\u4e0b\u5c5e\u6709\u65f6\u4e0d\u77e5\u9053\u8be5\u600e\u4e48\u505a\u3002\u90a3\u53ef\u80fd\u662f\u56e0\u4e3a\u4f60\u5bf9\u4ed6\u4eec\u7684\u8868\u73b0\u8f83\u5c11\u7ed9\u4e88\u53cd\u9988\u6216\u53ea\u7ed9\u8d1f\u9762\u53cd\u9988\u3002<br\/>\n*\u4e0b\u5c5e\u7ee9\u6548\u603b\u662f\u65e0\u6cd5\u8fbe\u6807\u3002\u90a3\u53ef\u80fd\u662f\u56e0\u4e3a\u4f60\u8f83\u5c11\u63d0\u4f9b\u660e\u786e\u7684\u6307\u5f15\u6216\u53cd\u9988\uff0c\u6765\u5e2e\u52a9\u4e0b\u5c5e\u6539\u5584\u7ee9\u6548\u3002",
    //       "development": "\u563f\uff0c\u653e\u8f7b\u677e\uff0c\u4e0d\u8981\u505a\u56e2\u961f\u7684\u72ec\u88c1\u8005\u54e6\uff01\u4e0d\u7136\u4e0b\u5c5e\u4f1a\u4ee5\u4e3a\u4ed6\u4eec\u5728\u4e3a\u4e00\u4e2a\u673a\u5668\u4eba\u5de5\u4f5c\u3002<br \/>\n\u5c1d\u8bd5\u771f\u5207\u5173\u6ce8\u4e0b\u5c5e\u53d1\u5c55\u9700\u6c42\u5427\uff1a\u6df1\u5165\u4e86\u89e3\u4e0b\u5c5e\u7684\u4e2a\u4eba\u548c\u5de5\u4f5c\u53d1\u5c55\u9700\u6c42\uff0c\u5728\u5206\u914d\u4efb\u52a1\u548c\u6307\u5bfc\u4e0b\u5c5e\u524d\uff0c\u601d\u8003\u4e00\u4e0b\u4ed6\u4eec\u7684\u4e2a\u4eba\u9700\u6c42\uff0c\u5e76\u636e\u6b64\u63d0\u4f9b\u652f\u6301\u548c\u5e2e\u52a9\uff0c\u4f1a\u4f7f\u8f85\u5bfc\u4e8b\u534a\u529f\u500d\u54e6\uff01<br \/>\n\u5f00\u653e\u7075\u6d3b\u7684\u4e2a\u6027\u4f7f\u4f60\u5728\u9762\u5bf9\u6311\u6218\u65f6\uff0c\u613f\u610f\u4e3a\u4e0b\u5c5e\u548c\u56e2\u961f\u63d0\u4f9b\u66f4\u591a\u7684\u53c2\u4e0e\u548c\u51b3\u7b56\u673a\u4f1a\uff0c\u8ba9\u4ed6\u4eec\u5728\u5de5\u4f5c\u4e2d\u611f\u53d7\u5230\u66f4\u591a\u7684\u81ea\u4e3b\u6743\u3002\u7684\u786e\uff0c\u52a8\u529b\u662f\u63d0\u5347\u8f85\u5bfc\u6548\u679c\u7684\u4e00\u5242\u826f\u836f\uff0c\u6fc0\u52b1\u662f\u56e2\u961f\u6f5c\u80fd\u91ca\u653e\u7684\u50ac\u5316\u5242\u3002<br \/>\n\u660e\u786e\u4f20\u8fbe\u671f\u671b\u2014\u2014\u4f46\u8fd9\u6837\u7684\u4e2a\u6027\u4e5f\u53ef\u80fd\u4f1a\u8ba9\u4f60\u5ffd\u89c6\u7ec6\u8282\uff0c\u5728\u4f20\u8fbe\u8f85\u5bfc\u671f\u671b\u65f6\u8fc7\u4e8e\u6a21\u7cca\uff0c\u4e0b\u5c5e\u6267\u884c\u4efb\u52a1\u6216\u53d1\u5c55\u65f6\u4e5f\u5c31\u53ef\u80fd\u8fc7\u4e8e\u653e\u98de\u4e86\u3002\u8bf7\u5c3d\u91cf\u4f20\u8fbe\u660e\u786e\u4e14\u53ef\u8861\u91cf\u7684\u671f\u671b\uff0c\u6709\u9488\u5bf9\u6027\u5730\u63d0\u4f9b\u53d1\u5c55\u7a7a\u95f4\u548c\u6307\u5bfc\uff0c\u4f1a\u6709\u66f4\u5927\u7684\u6536\u83b7\u54e6\uff01<br \/>",
    //       "created_time": "2018-06-07 10:48:08",
    //       "updated_time": "2018-06-07 10:48:08",
    //       "name": "\u8f85\u5bfc",
    //       "explanation": "Text6",
    //       "low_level_explanation": null,
    //       "high_level_explanation": null
    //     }]
    //   }
    // }
    //
    // getMockData2(){
    //   return {
    //     "id": 2150,
    //     "name": "\u8f85\u5bfc",
    //     "description": "\u60f3\u8981\u5e26\u9886\u4e00\u652f\u5b9e\u529b\u51fa\u4f17\u7684\u68a6\u4e4b\u961f\uff1f\u4f46\u4f60\u77e5\u9053\u4e48\uff0c\u56e2\u961f\u5176\u5b9e\u662f\u9886\u5bfc\u8005\u7684\u5012\u5f71\u3002\u589e\u5f3a\u4f60\u7684\u8f85\u5bfc\u80fd\u529b\uff0c\u56e2\u961f\u8868\u73b0\u5c06\u66f4\u6770\u51fa\u3002<br\/>\n\u8fd9\u6b21\u5b66\u4e60\u65c5\u7a0b\u4e2d\uff0c\u6211\u4eec\u5c06\u4e00\u8d77\u63a2\u7d22\u8f85\u5bfc\u4e0b\u5c5e\u7684\u6709\u6548\u65b9\u6cd5\uff0c\u76f4\u81f3\u8f85\u5bfc\u529bMAX\uff0c\u4e0b\u5c5e\u8868\u73b0\u66f4\u4f18\u3002\n",
    //     "targetUser": "\u53f6\u5ead\u541b\uff08Mindy\uff09",
    //     "goal": "test",
    //     "totalHours": 100,
    //     "status": 2,
    //     "feedbackPoped": 0,
    //     "subItems": [{"guide": "\u5f15\u5bfc", "type": 0, "progress": 100}, {
    //       "id": 3310,
    //       "type": 1,
    //       "surveyMetaId": 2,
    //       "progress": "100.00"
    //     }, {"id": 825, "type": 2, "courseMetaId": 1, "progress": 100}, {
    //       "id": 2138,
    //       "type": 3,
    //       "practiceMetaId": 1,
    //       "progress": 100
    //     }, {"id": 3311, "type": 4, "surveyMetaId": 3, "progress": "100.00"}, {
    //       "id": 1,
    //       "type": 5,
    //       "celebrationMetaId": 1,
    //       "progress": 0
    //     }],
    //     "currentItemIndex": 5,
    //     "currentItemType": 5,
    //     "exerciseBeginInDays": null,
    //     "finished": false
    //   }
    // }
  }



// WEBPACK FOOTER //
// ./src/app/ability-test-report/ability-test-report.component.ts